import { Project } from '../domain/project';
import { RProject } from '../remote/project';
import { mapTopics } from '../../Topic';
import { parseISO } from 'date-fns';
import { getLogger } from '../../../logger/logger';
import { removeEmptyValues } from '../../../utils';
import { mapRImage, mapRImages } from '../../../api/helpers';
import { mapTestimonial } from '../../Testimonial';
import { Administration, Association, Company, mapInstitution } from '../../Institution';

const logger = getLogger('mapProjectLogger');

export const mapProject = (project: RProject | null): Project | null => {
    if (!project) return null;
    const {
        id,
        documentId,
        title,
        text_section_0,
        startDate,
        endDate,
        topics,
        text_section_1,
        text_section_2,
        testimonials,
        titleImage,
        media,
        client,
        partnerCompany,
        createdAt,
        updatedAt,
        publishedAt
    } = project;
    const hasTimeFrame = startDate && endDate;

    try {
        return {
            id,
            documentId,
            title,
            text_section_0: text_section_0 ?? '',
            duration: hasTimeFrame
                ? { start: parseISO(startDate), end: parseISO(endDate) }
                : undefined,
            text_section_1: text_section_1 ?? undefined,
            text_section_2: text_section_2 ?? undefined,
            testimonial: testimonials?.length ? mapTestimonial(testimonials[0]) : undefined,
            titleImage: mapRImage(titleImage),
            media: mapRImages(media),
            topics: mapTopics(topics),
            client: client ? (mapInstitution(client) as Administration | Association) : undefined,
            partnerCompany: partnerCompany
                ? (mapInstitution(partnerCompany) as Company)
                : undefined,
            createdAt: parseISO(createdAt),
            updatedAt: parseISO(updatedAt),
            publishedAt: publishedAt ? parseISO(publishedAt) : null
        };
    } catch (e) {
        logger.error(
            `While mapping project with id: ${project.documentId} following error occurred: ${e}`
        );
        return null;
    }
};

/**
 * Maps an array of RProject to Project data.
 *
 * If the mapping fails for an object it will be filtered out of the array.
 *
 * @param projects the list of RProjects to map
 */
export const mapProjects = (projects?: RProject[] | null): Project[] => {
    const mappedProjects =
        projects !== null && projects !== undefined
            ? removeEmptyValues(projects.map(mapProject))
            : [];

    return mappedProjects;
};
